import { render, staticRenderFns } from "./EditRedEnvelopDialoge.vue?vue&type=template&id=2ee7b423&scoped=true&"
import script from "./EditRedEnvelopDialoge.vue?vue&type=script&lang=js&"
export * from "./EditRedEnvelopDialoge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7b423",
  null
  
)

export default component.exports